// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputSearch {
  border-radius: 8px;
  padding: 4px;
  background-color: #fff;
  position: relative;
}
.InputSearch .Input {
  border-radius: 8px;
  background-color: #f7f8fc;
  padding-left: 60px;
  font-size: 16px;
  padding-top: 15px;
  width: 100%;
  padding-bottom: 15px;
  font-family: "Montserrat Regular";
  border: none;
  outline: none;
}
.InputSearch .Search {
  position: absolute;
  left: 24px;
  top: 19px;
}`, "",{"version":3,"sources":["webpack://./src/components/InputSearch/InputSearch.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;AAEJ;AAAE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAEJ","sourcesContent":[".InputSearch {\r\n  border-radius: 8px;\r\n  padding: 4px;\r\n  background-color: #fff;\r\n  position: relative;\r\n  .Input {\r\n    border-radius: 8px;\r\n    background-color: #f7f8fc;\r\n    padding-left: 60px;\r\n    font-size: 16px;\r\n    padding-top: 15px;\r\n    width: 100%;\r\n    padding-bottom: 15px;\r\n    font-family: 'Montserrat Regular';\r\n    border: none;\r\n    outline: none;\r\n  }\r\n  .Search {\r\n    position: absolute;\r\n    left: 24px;\r\n    top: 19px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"InputSearch": `InputSearch`,
	"Input": `Input`,
	"Search": `Search`
};
export default ___CSS_LOADER_EXPORT___;
